/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type { DamsVariables, Dams, Dams_dams_Dams_results_Dam as Dam } from './types/index.graphql'

export const DAMS = gql`
  query Dams(
    $fieldId: Int!
    $includeCalendar: Boolean!
    $toYearMonth: String
    $fromYearMonth: String
    $includeMapUrls: Boolean!
  ) {
    dams(fieldId: $fieldId) {
      results {
        id
        name
        area {
          type
          coordinates
        }
        location {
          coordinates
          type
        }
        calendar(fromYearMonth: $fromYearMonth, toYearMonth: $toYearMonth)
          @include(if: $includeCalendar) {
          date
          mapUrls {
            waterSurface {
              url @include(if: $includeMapUrls)
              isAvailable
              weatherType
              provider
              area
              volume
              percentage
            }
          }
        }
      }
    }
  }
`
